import {
  animate,
  animation,
  style,
  transition,
  trigger,
  useAnimation,
} from '@angular/animations';

export const fadeInAnimation = animation([
  style({ opacity: 0 }),
  animate('{{duration}}ms {{delay}}ms', style({ opacity: 1 })),
]);

export const fadeOutAnimation = animation([
  style({ opacity: 1 }),
  animate('{{duration}}ms {{delay}}ms', style({ opacity: 0 })),
]);

export const fade = trigger('fade', [
  transition(
    ':enter',
    useAnimation(fadeInAnimation, {
      params: {
        duration: 300,
        delay: 0,
      },
    }),
  ),
  transition(
    ':leave',
    useAnimation(fadeOutAnimation, {
      params: {
        duration: 300,
        delay: 0,
      },
    }),
  ),
]);
